const $ = require('jquery');
global.$ = global.jQuery = $;

require('slick-carousel');
require('slick-carousel/slick/slick.css');
require('slick-carousel/slick/slick-theme.css');

const Splide = require('@splidejs/splide').Splide;
const AutoScroll = require('@splidejs/splide-extension-auto-scroll').AutoScroll;

require('@splidejs/splide/css/core');

window.Splide = Splide;
window.SplideAutoScroll = { AutoScroll };

require('bootstrap');
